export default __webpack_public_path__ + "static/food-5e089a1f2f4a8a806e66123a0c2179e0.png";